import { Injectable } from '@angular/core';
import { ServiceResponse } from "../../data/models/service/service-response";
import { RequestOptionsArgs, RequestOptions, ResponseContentType, Http, Response, Headers } from '@angular/http';

declare var serverConfig: { [id: string]: any };

@Injectable()
export class SSO {
    private primaryServiceAddress: string = serverConfig["serviceAddress"];
    private buddyServiceAddress: string = serverConfig["backupServiceAddress"];

    constructor(private http: Http) { }

    public async getSSOSettings(): Promise<ServiceResponse<Array<any>>> {
        let response: Response = null;
        let ret: Array<any> = [];
        try {
            response = await this.http.get(this.primaryServiceAddress + "/api/SSOSettings", new RequestOptions({
                headers: new Headers({ "Content-Type": "application/json" }),
                responseType: ResponseContentType.Json
            })).toPromise();
        } catch (e) {
            try {
                response = await this.http.get(this.buddyServiceAddress + "/api/SSOSettings", new RequestOptions({
                    headers: new Headers({ "Content-Type": "application/json" }),
                    responseType: ResponseContentType.Json
                })).toPromise();
            } catch (e) {
                throw e;
            }
        }
        if (response && response.json()) {
            for (let p of response.json()) {
                ret.push(p);
            }

            return new ServiceResponse<Array<any>>(true, ret);
        } else {
            return new ServiceResponse<Array<string>>(false, ret);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/providers/nom-web-services-json/sso.ts